<template>
  <div class="levelUpBox">
    <nav-bar :title="$t('权益等级升级')" bg-color="transparent" left-arrow left-color="#fff" title-color="#fff"/>
    <div class="levelBox">
      <div class="level">
        <p class="top">
          <span class="lv">{{ next.level_name || "" }}VIP</span>
          <span class="name">{{ info.account || "" }}</span>
          <img alt="" class="bgImg" src="@/assets/img/mine14.png">
        </p>
        <p class="lvTxtBox">
          <span class="lvTxt">{{ $t('可升级') }} {{ next.next_level_name || "" }} VIP，{{ $t('需') }} {{ next.next_amount || "0.00" }} {{ $t('注册币') }}</span>
          <span class="lvPrice">{{ $t('注册币余额') }}：{{ info.coin || "0.00" }}</span>
        </p>
      </div>
      <div class="btnBox">
        <p class="btn" @click="upgradeDo()">{{ $t('立即升级') }}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      info: {},
      next: {},
    }
  },
  computed: {},
  watch: {},
  methods: {
    getMemberInfo() {
      this.$get({
        url: `/member/getMemberInfo`,
        loading: true,
        success: (res) => {
          this.info = res.data
          this.getNextLevel()
        },
        tip: () => {
        }
      })
    },
    getNextLevel() {
      this.$get({
        url: `/member/getNextLevel`,
        loading: true,
        success: (res) => {
          this.next = res.data
        },
        tip: () => {
        }
      })
    },
    upgradeDo() {
      this.$get({
        url: `/upgradeLog/upgradeDo`,
        loading: true,
        success: (res) => {
          this.$toast(res.message)
        },
        tip: () => {
        }
      })
    },
  },
  created() {
    this.getMemberInfo()
  },
  mounted() {
  },
}
</script>

<style lang="less" scoped>
.levelUpBox {
  width: 100%;
  min-height: 100vh;
  background-color: #446D7A;
  padding: 15px;

  .levelBox {
    .level {
      padding: 20px;
      border-radius: 10px;
      background: linear-gradient(180deg, #534A3B 0%, #2F2820 100%);

      .top {
        position: relative;
        display: flex;
        flex-direction: column;

        .lv {
          font-size: 20px;
          font-weight: bold;
          color: #ffffff;
        }

        .name {
          color: #91897e;
          font-size: 12px;
        }

        .bgImg {
          position: absolute;
          width: 76px;
          height: 76px;
          right: -5px;
          top: -5px;
        }
      }

      .lvTxtBox {
        display: flex;
        flex-direction: column;
        margin-top: 30px;

        .lvTxt {
          color: #AEAAA1;
        }

        .lvPrice {
          font-size: 10px;
          color: #E5D3B2;
        }
      }
    }

    .btnBox {
      padding: 0 20px;

      .btn {
        padding: 12px 0;
        text-align: center;
        color: #ffffff;
        background: linear-gradient(145deg, #b99c65, #a88b59);
        border-radius: 6px;
        margin-top: 80px;
        box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3), 
                    -5px -5px 10px rgba(255, 255, 255, 0.1);
        transition: all 0.3s ease;
        position: relative;
        overflow: hidden;
        transform: perspective(1000px) rotateX(2deg);
        cursor: pointer;
      }
      
      .btn:hover {
        background: linear-gradient(145deg, #c5aa75, #b99c65);
        box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.35), 
                    -6px -6px 12px rgba(255, 255, 255, 0.15);
        transform: perspective(1000px) rotateX(1deg) translateY(-2px);
      }
      
      .btn:active {
        background: linear-gradient(145deg, #a88b59, #977a49);
        box-shadow: inset 3px 3px 6px rgba(0, 0, 0, 0.3), 
                    inset -3px -3px 6px rgba(255, 255, 255, 0.1);
        transform: perspective(1000px) rotateX(0deg) translateY(0);
      }
    }
  }
}
</style>
